import Api from '@/api/api.js'

export default {
    /**
     * Route pour recuperer les entres
     */
    entres() {
        const promise = Api().get("/liste-entres");
        return promise.then((response) => response.data);
    },

    /**
     * Route pour sauvegarder une entre de stock
     */
    saveEntre(data) {
        const promise = Api().post("/entre-stock", data);
        return promise.then((response) => response.data);
    },

    /**
     * Route pour recuperer une entre
     */
    getEntre(id) {
        const promise = Api().get("/entre/" + id);
        return promise.then((response) => response.data);
    },

    dateFilter(data) {
        const promise = Api().post("/entre-date", data);
        return promise.then((response) => response.data);
    },
    
    getFiltrage_entre_date(data) {
        const promise = Api().post("/entre-date-between", data);
        return promise.then((response) => response.data);
    },
};